export const environment = {
  production: false,
  clientId: '57b82c09-0a9f-4aa1-ba02-2fe1129e91a4',
  redirectUri: 'https://corpaf-dev-cvx.azure.chevron.com/',
  security: {copilotAccessGroupId: 'dae1f5e3-9b25-4983-aa46-e6ec5db1d3ba'}
};